<template>
  <header
    v-if="$route.name !== 'Offer'"
    id="enter"
    :class="{
      openedLayer: $store.getters.getOpenedLayer,
      small: this.$route.name === 'Offices',
      hideonmobile: this.$route.name === 'Offices',
    }"
  >
    <div
      :class="{
        small: small,
        closed: showHeader,
        onlylogo: !up,
        mobile: isMobile(),
        opennav: navIsOpen,
      }"
      class="header-container"
    >
      <div class="container">
        <router-link to="/#enter" ref="logo" class="logo-link">
          <img
            class="black"
            loading="lazy"
            decoding="async"
            src="@/assets/offie-logo-black.svg"
            width="122"
            height="38"
            alt="Offie"
            title=""
          />
          <img
            class="white"
            loading="lazy"
            decoding="async"
            src="@/assets/offie-logo-white.svg"
            width="88"
            height="28"
            alt="Offie"
            title=""
          />
        </router-link>
        <div class="navigation">
          <nav>
            <router-link
              class="text"
              :to="{ path: '/', hash: 'az-offie-elonyei' }"
              >Miért Offie</router-link
            >
            <router-link class="text" :to="{ path: '/', hash: 'rolunk' }"
              >Kik vagyunk</router-link
            >
            <router-link
              class="text"
              :to="{ path: contactPath, hash: 'kapcsolat' }"
              >Kapcsolat</router-link
            >
            <router-link
              class="text"
              :to="{ path: '/blog?page=1', hash: 'enter' }"
              >Blog</router-link
            >
            <!-- <Button
              :to="{ path: '/kerdoiv/start' }"
              @click.native="closeNavigation()"
              arrow="right"
              class="white"
              >Tovább a kérdőívhez
            </Button> -->
            <Button
              :to="{ path: '/irodak' }"
              @click.native="closeNavigation()"
              arrow="right"
              class="white"
              >Térképes irodakereső
            </Button>
          </nav>
        </div>
        <button class="button hamburger" @click="toggleNavigation()">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
  import Button from "@/components/inputs/Button.vue";

  export default {
    name: "Header",
    components: {
      Button,
    },
    data: () => ({
      up: false,
      small: true,
      navIsOpen: false,
      showHeader: true,
      scrollPosition: 0,
      lastScrollPosition: 0,
      scrollOffset: 40,
      contactPath: "/",
    }),
    mounted() {
      // this.lastScrollPosition = 0;
      // window.addEventListener("scroll", this.onScroll);
      // this.onScroll();
      // this.$root.$on("refreshHeader", () => {
      //   this.onScroll();
      // });
    },
    watch: {
      $route(to, from) {
        if (to.path == "/blog") {
          this.contactPath = "/blog";
        } else {
          this.contactPath = "/";
        }
      },
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
      isMobile() {
        if (screen.width <= 500) {
          return true;
        } else {
          return false;
        }
      },
      toggleNavigation() {
        this.navIsOpen = !this.navIsOpen;
      },
      closeNavigation() {
        this.navIsOpen = false;
      },
      onScroll() {
        this.scrollPosition = window.pageYOffset;
        this.scrollDif = Math.abs(
          this.scrollPosition - this.lastScrollPosition
        );
        this.small = true;
        // console.log(this.scrollPosition, this.lastScrollPosition);
        if (this.scrollPosition === 0 && this.$route.name !== "Offices") {
          this.small = false;
        }
        if (
          this.scrollPosition <= 0 ||
          (this.isMobile() && this.scrollDif != 0)
        ) {
          this.showHeader = false;
          this.navIsOpen = false;
          return;
        }
        if (this.scrollDif < this.scrollOffset) {
          return;
        }
        this.showHeader = this.scrollPosition >= this.lastScrollPosition;
        this.up = this.scrollPosition - this.lastScrollPosition < 0;
        this.navIsOpen = this.navIsOpen && this.up;
        this.lastScrollPosition = this.scrollPosition;
      },
    },
  };
</script>

<style lang="scss">
  header {
    position: relative;
    z-index: 1000;
    width: 100%;
    // height: 88px;
    height: 100px;
    background: $background;
    &.openedLayer {
      z-index: 3;
    }
    &.small {
      height: 66px;
    }
    &.hideonmobile {
      @media (max-width: $breakpoint) {
        height: 0;

        .header-container .logo-link {
          display: none;
        }
      }
    }
    .header-container {
      /*position: relative;
    top: 0;
    width: 100%;*/
      // background: $lightgray;
      // transform: translateY(0);
      transition: all 0.3s ease-in-out;

      .logo-link {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        left: 16px;
        top: 30px;
        z-index: 10;
        img {
          height: auto;
          &.black {
            display: block;
            width: 85px;
          }
          &.white {
            display: none;
            width: 85px;
          }
        }
      }

      .hamburger,
      .logo-link,
      .navigation {
        position: fixed;
        transition: all 0.3s ease-in-out;
      }

      .logo-link {
        position: absolute;
        transition: all 0.3s ease-in-out;
      }

      &.closed {
        .navigation {
          // transform: translateY(-100%);
        }
      }

      // &.closed,
      &.opennav {
        .navigation {
          transform: translateY(0);
        }
        .hamburger {
          background: $transparent;
          box-shadow: 0 0 0 0 $transparent;
          span {
            &:nth-child(1) {
              transform: translateY(7px) rotate(45deg);
            }
            &:nth-child(2) {
              opacity: 0;
            }
            &:nth-child(3) {
              transform: translateY(-7px) rotate(-45deg);
            }
          }
        }
      }

      .container {
        position: static;
        /*position: fixed;
      width: 100%;
      top: 0;*/
        display: flex;
        justify-content: space-between;
        // padding: 64px 0 16px 0;
      }

      .navigation {
        right: 0;
        bottom: 0;
        left: 0;
        padding: 16px;
        border-radius: 12px 12px 0 0;
        background: $lightgray;
        transform: translateY(120%);
        box-shadow: 0 0 24px 0px $midgray;
        nav {
          width: 100%;
          width: 100%;
          padding-bottom: 64px;
          display: flex;
          flex-direction: column;
          // text-align: right;

          a {
            text-decoration: none;
            padding: 16px 0;
            font-weight: 500;
          }
          .button {
            margin-top: 16px;
            padding: 16px 20px;
            background: $blue;
            color: $white;
          }
        }
      }

      .hamburger {
        position: fixed;
        bottom: 16px;
        right: 16px;
        width: 56px;
        height: 56px;
        max-height: 56px;
        padding: 17px 17px 21px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        background: $lightgray;
        border-radius: 50%;
        box-shadow: 0 2px 6px 0 rgba($gray, 0.2);
        gap: 3px;
        span {
          display: block;
          background: $black;
          height: 2px;
          min-height: 2px;
          transition: all 0.3s ease-in-out;
          width: 100%;
          //border: 1px solid $black;
          border-radius: 2px;
          overflow: hidden;
        }
      }
    }

    @media screen and (min-width: $breakpoint) {
      position: relative;
      // position: fixed;
      // height: 94px;
      .header-container {
        width: 100%;
        position: fixed;
        .container {
          padding-top: 24px;
          padding-bottom: 24px;
        }
        .logo-link {
          position: relative;
          left: 0;
          top: 0;
          img {
            width: 184px;
            height: auto;
          }
        }
        &.small {
          background: $black;
          transform: translateY(-32px);
          //&.onlylogo {
          .logo-link {
            transform: translateY(16px);
            //filter: invert(1);
            img {
              &.white {
                display: block;
              }
              &.black {
                display: none;
              }
            }
          }
          //}
          .navigation {
            transform: translateY(16px);
            a {
              color: $white;
              /* &.button {
              color: $black;
            } */
              &.text {
                &:after {
                  background: $white;
                }
              }
            }
            .button {
              background-color: $blue;
            }
          }
        }
        .navigation {
          position: relative;
          border-radius: 0;
          background: none;
          transform: translateY(0);
          padding: 0;
          box-shadow: none;
          nav {
            width: auto;
            padding-bottom: 0;
            flex-direction: row;
            align-items: center;
            a.text {
              padding: 16px 12px;
              position: relative;
              &:hover {
                &:after {
                  opacity: 1;
                  left: 12px;
                  right: 12px;
                }
              }
              &:after {
                content: "";
                height: 2px;
                position: absolute;
                left: 50%;
                right: 50%;
                bottom: 10px;
                opacity: 0;
                background: $black;
                transition: all 0.3s ease-in-out;
              }
            }
            .button {
              margin-top: 0;
              margin-left: 52px;
            }
          }
        }
        .hamburger {
          display: none;
        }
      }
    }
  }
</style>
